import { BadgeStatus } from '@/components/badge-order';
import DataTableColumnHeader from '@/components/commons/data-table/data-table-column-header';
import { CustomerOrderElementDataType } from '@/components/sections/builder/elements/body/customer/customer_order/type';
import { Button } from '@/components/ui/button';
import useModal from '@/hooks/useModal';
import { formatIDR } from '@/lib/utils';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';

export interface CustomerOrderProps {
  order_id: string;
  order_no: string;
  grand_total: number;
  status: string;
  created_at: string;
}

export const columnsCustomerOrder = (
  drawer: ReturnType<typeof useModal>,
  content?: CustomerOrderElementDataType
): ColumnDef<CustomerOrderProps>[] => {
  const propsColumns = {
    enableSorting: false,
    enableHiding: false,
  };

  const columns: ColumnDef<CustomerOrderProps>[] = [
    {
      id: 'order_no',
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title='No. Order'
          className='pl-3 text-base text-[#45464E]'
        />
      ),
      cell: ({ row }) => {
        const recordValue = row.original;

        const handleOnClick = () => {
          drawer.open({ order_id: recordValue.order_id });
        };

        return (
          <>
            <div className='py-2 pl-3'>
              <Button
                type='button'
                // className='underline-offset-4 hover:underline'
                variant='link'
                style={
                  content?.colorScheme
                    ? {
                        color: content?.colorScheme.textSecondary,
                        backgroundColor: 'transparent',
                      }
                    : {}
                }
                onClick={handleOnClick}
              >
                #{recordValue.order_no}
              </Button>
            </div>
          </>
        );
      },
      ...propsColumns,
    },
    {
      id: 'created_at',
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title='Date' className='text-base' />
      ),
      accessorFn: (row) => format(row.created_at, 'dd MMM yyyy'),
      ...propsColumns,
    },
    {
      id: 'status',
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title='Status'
          className='text-base text-[#45464E]'
        />
      ),
      cell: ({ row }) => {
        const recordValue = row.original;
        return <BadgeStatus status={recordValue.status.toLowerCase()} />;
      },
      ...propsColumns,
    },
    {
      id: 'grand_total',
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title='Total' className='text-base text-[#45464E]' />
      ),
      accessorFn: (row) => formatIDR(row.grand_total),
      ...propsColumns,
    },
  ];

  return columns;
};
